<template>
  <div class="recommend">
    <div class="content">
      <div class="merchantRe">{{ $t('homePage.exhibition.title') }}</div>
      <!-----展商推荐列表------->
      <div class="box">
        <div class="item" v-for="(item, index) in merchantsExhibits" :key="index" @click="goDetail(item.id)">
          <div class="left">
            <img :src="item.leftImgUrl" alt="" v-if="item.leftImgUrl.substr(0,4)=='http'"/>
            <img :src="baseUrl+item.leftImgUrl" alt="" v-else/>
          </div>
          <div class="right">
            <div class="top">
              <div class="title">{{ item.title }}</div>
              <div class="txt">
                <span class="booth">{{ $t('exhibition.boothNum') }}</span
                ><span class="contentBooth">{{ addcomma(item.txt) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--查看更多-->
      <router-link to="exhibition"
        ><div class="lookMore">{{ $t('common.viewMore') }}</div></router-link
      >
    </div>
  </div>
</template>
<script>
import { getrecommendedExhibitor, addCollect } from '../../../../api/homePage';
import { forMat } from '../../../../utils/common';
import * as tools from '../../../../utils/roulink';

export default {
  data() {
    return {
      //商家推荐
      merchantsExhibits: [],
      baseUrl: forMat(),
      lang: 'zh'
    };
  },
  methods: {
    consult(item) {
      tools.login(1, item.id);
    },
    async getrecommendedExhibitor() {
      try {
        let { data } = await getrecommendedExhibitor();
        data.data.list.forEach((item, i) => {
          this.merchantsExhibits.push({
            id: item.id,
            leftImgUrl: item.comCover,
            title: this.lang == 'zh' ? item.companyNameC : item.companyNameE,
            collectStatus: item.collectStatus,
            // txt:item.hzBoothList[0].boothNum
          });
          item.hzBoothList.length > 0
            ? (this.merchantsExhibits[i].txt = item.hzBoothList.map((item) => {
                return item.boothNum;
              }))
            : (this.merchantsExhibits[i].txt = this.$t('homePage.exhibition.no'));
        });
      } catch (e) {
        console.log(e);
      }
    },

    addcomma(arr) {
      return arr.join('、');
    },

    //使用父组件收藏方法
    collection(item, type) {
      this.$parent.collection(item, type);
    },

    //
    //跳转
    goDetail(id) {
      this.$router.push({
        name: 'exhibition_det',
        query: {
          id,
        },
      });
    },
  },
  created() {
    this.getrecommendedExhibitor();
    const language = localStorage.getItem('lang');
    this.$i18n.locale = language == 'en' ? language : 'zh';
    this.lang = language == 'en' ? language : 'zh';
  },
};
</script>
<style lang="scss" scoped>
.recommend {
  background-image: url('../../../static/IMG_recom.png');
  padding-bottom: 9.3vw;
  .content {
    width: 100%;
    margin: 0 auto;
    padding-top: 10.8vw;
    height: fit-content;
    .merchantRe {
      width: 100%;
      font-size: 4.8vw;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #333333;
      text-align: center;
    }
    .box {
      width: 100%;
      margin-top: 7.2vw;
      padding-left: 4vw;
      padding-right: 4vw;
      box-sizing: border-box;
      .item:hover {
        box-shadow: 2px 2px 10px #9fa3a5;
      }
      .item {
        width: 100%;
        height: 22.7vw;
        border: 1px solid #e0e0e0;
        margin-bottom: 3.7vw;
        display: flex;
        justify-content: space-between;
        flex-wrap: nowrap;
        background-color: white;

        .left {
          width: 39.5vw;
          height: 22.7vw;
          display: flex;
          justify-content: center;
          align-items: center;
          border-right: 0.1vw solid #e0e0e0;
          padding: 3.1vw 5.3vw;
          box-sizing: border-box;
          img {
            max-width: 33.9vw;
            max-height: 22.7vw;
          }
        }
        .right {
          flex: 1;
          height: 22.7vw;

          .top {
            width: 100%;
            height: 100%;
            padding: 4vw;
            display: flex;
            box-sizing: border-box;
            flex-direction: column;
            justify-content: space-between;
            .title {
              font-size: 3.7vw;
              color:#333;
              font-family: Microsoft YaHei;
              font-weight: 400;
              width: 100%;
              max-width: 39vw;
              line-height: 4.8vw;
              text-overflow: -o-ellipsis-lastline;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              line-clamp: 2;
              -webkit-box-orient: vertical;
            }
            .txt {
              font-family: Microsoft YaHei;
              color: #333333;
              font-size: 4.3vw;
              .booth {
                font-size: 3.2vw;
                font-weight: 400;
                color: #333333;
                width: 100%;
                max-width: 39vw;
                font-family: Microsoft YaHei;
              }
              .contentBooth {
                font-size: 4.3vw;
                margin-left: 0.7vw;
                font-weight: bold;
                color: #333;
                font-family: Microsoft YaHei;
              }
            }
          }
        }

        &:hover {
          color: #006fb8 !important;
          .top {
            .txt {
              color: #006fb8 !important;
              span {
                color: #006fb8 !important;
              }
            }
          }
        }
      }
    }
    a {
      text-decoration: none;
      .lookMore {
        width: 48vw;
        height: 9.6vw;
        border: 1px solid #333333;
        border-radius: 1vw;
        margin: 0 auto;
        text-align: center;
        line-height: 4.3vw;
        margin-top: 6.6vw;
        color: #333333;
        font-size: 4.3vw;
        padding-top: 2.6vw;
        padding-bottom: 2.6vw;
        box-sizing: border-box;
        font-family: Microsoft YaHei;
      }
    }
  }
}
</style>
